<script setup>
import Logo from './Logo.vue';

defineProps({
  logo: {
    type: String,
    required: true
  },
  headerText: {
    type: String,
  }
});
</script>

<template>
  <div class="preview">
    <div class="preview__header">
      <slot name="header-content"/>
    </div>
    <div class="preview__container">
      <div class="preview__container__form">
        <logo :logo="logo"/>
        <div v-if="headerText" class="header">
          {{ headerText }}
        </div>
        <slot name="form-content"/>
        <slot name="form-footer"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.preview {
  position: relative;
  width: 453px;
  background-color: #5E2F7814;
  border-radius: 12px;
  padding: 24px 0 24px 0;

  &__header {
    padding: 0 24px 24px 24px;

    :first-child {
      margin-top: 0;
    }
    :last-child {
      margin-bottom: 0;
    }
    p {
      font-size: 12px;
    }
    h2 {
      margin: 0;
    }
  }

  &__container {
    padding: 0 24px;

    &__form {
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 40px;
      border-radius: 12px;
      box-shadow: 0px 2px 6px 2px #00000026;

      .header{
        text-align: center;
        font-weight: 600;
        font-size: 24px;
        line-height: 28.8px;
        padding-bottom: 30px;
        word-wrap: break-word;
      }
    }
  }
}
</style>
